import { z } from 'zod';

const vatTuSanPhamSchemaRaw = z.object({
  ma_vt: z.string().min(1, 'Mã vật tư không được để trống'),
  ten_vt: z.string().min(1, 'Tên vật tư không được để trống'),
  ten_vt2: z.string().optional().nullable(),
  ton_kho_yn: z.boolean(),
  lo_yn: z.boolean(),
  qc_yn: z.boolean(),
  gia_ton: z.coerce.number(),
  sua_tk_vt: z.boolean(),
  the_tich: z.coerce.number(),
  khoi_luong: z.coerce.number(),
  ma_vt2: z.string().optional().nullable(),
  kieu_hd: z.coerce.number(),
  sl_min: z.coerce.number(),
  sl_max: z.coerce.number(),
  ngay_nhap: z.string().optional().nullable(),
  ngay_xuat: z.string().optional().nullable(),
  ghi_chu: z.string().optional().nullable(),
  status: z.coerce.number()
});

// Export the schema
export const vatTuSanPhamSchema = vatTuSanPhamSchemaRaw;

export type VatTuSanPhamFormValues = z.infer<typeof vatTuSanPhamSchemaRaw>;

/**
 * Initial values for the VatTuSanPham form
 */
export const initialVatTuSanPhamValues: VatTuSanPhamFormValues = {
  ma_vt: '',
  ten_vt: '',
  ten_vt2: null,
  ton_kho_yn: true,
  lo_yn: false,
  qc_yn: false,
  gia_ton: 0,
  sua_tk_vt: false,
  the_tich: 0,
  khoi_luong: 0,
  ma_vt2: null,
  kieu_hd: 1,
  sl_min: 0,
  sl_max: 0,
  ngay_nhap: null,
  ngay_xuat: null,
  ghi_chu: null,
  status: 1
};
